// localMode — V3 słaby zasięg B-1, B9 „Tryb lokalny" (aneks 1 sekcja 3, T Martina 12.09.2026).
//
// Flaga PER URZĄDZENIE w IndexedDB (store `settings`, klucz `local_mode`): przeżywa restart
// aplikacji i wylogowanie; NIE gaśnie sama (zastępuje pomysł auto-wygaszania z 18.08).
// Włączony:
//   - zdjęcia wyłącznie do kolejki (queue-first i tak), uploadManager NIE startuje wysyłki,
//   - UI nie robi żadnych GET-ów do serwera (useApi: wyłącznie cache, także po TTL),
//   - jedyny wyjątek: ręczne „Wyślij teraz" (trigger/force) = jawne nadpisanie.
// To pauza synchronizacji, nie osobna ścieżka zapisu. Zero detekcji słabej sieci
// (navigator.onLine kłamie, Network Information API brak na iOS).
//
// Wartość trzymana także w pamięci (odczyt synchroniczny w apiFetch/processQueue);
// initLocalMode() ładuje ją z IDB przed renderem (main.jsx).

import { getSetting, setSetting } from './offlineDB.js';

export const LOCAL_MODE_KEY = 'local_mode';

let value = false;
let loaded = false;
const listeners = new Set();

function emit() {
  for (const fn of listeners) {
    try { fn(value); } catch { /* słuchacz nie wywraca nadawcy */ }
  }
}

/** Ładuje flagę z IDB (raz, przy starcie). Błąd IDB = tryb wyłączony (fail-open na sync). */
export async function initLocalMode() {
  try {
    value = (await getSetting(LOCAL_MODE_KEY)) === true;
  } catch {
    value = false;
  }
  loaded = true;
  emit();
  return value;
}

/** Synchroniczny odczyt (po initLocalMode; przed nim = false). */
export function isLocalMode() {
  return value;
}

export function isLocalModeLoaded() {
  return loaded;
}

/** Zapis flagi (IDB + pamięć) i powiadomienie słuchaczy. */
export async function setLocalMode(next) {
  value = next === true;
  loaded = true;
  try { await setSetting(LOCAL_MODE_KEY, value); } catch { /* pamięć i tak ustawiona */ }
  emit();
  return value;
}

export function subscribeLocalMode(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Test hook: reset stanu w pamięci (backing IDB resetuje offlineDB.__useMockBacking). */
export function __resetLocalModeForTest() {
  value = false;
  loaded = false;
  listeners.clear();
}
